import { useState } from "react";
import {
  getClienteZonaById,
  asignarZonasPorGps,
} from "../../services/ClientesZonasServices";
import { ClientesZonasFormContext } from "./ClientesZonasContext";

export const ClientesZonasState = ({ children }) => {
  const [report, setReport] = useState({});

  async function getClienteZonaByIdData(id) {
    let res = await getClienteZonaById(id);
    if (res) setReport(res);
    return res;
  }

  async function asignarZonasPorGpsData(user_id, latitud, longitud) {
    return await asignarZonasPorGps(user_id, latitud, longitud);
  }

  return (
    <ClientesZonasFormContext.Provider value={{
      report,
      getClienteZonaByIdData,
      asignarZonasPorGpsData,
    }}>
      {children}
    </ClientesZonasFormContext.Provider>
  );
};
